import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box, Button, Divider, Flex, Paragraph, Text, useColorMode } from "theme-ui";
import { getAllMasterDataForTable } from "../../../store/actions/masterData.action";
import { getAllUserWithoutPagination } from "../../../store/actions/user.action";
import { HeaderBtn } from "../../Button/TabelHeadBtn";
import Export from "../../assets/images/Icon/Export.svg";
import { useFormik } from "formik";
import DataTable from "../../Tabels/Tabel";
import { getAllProjectMasterData } from "../../../store/actions/project.action";
import { getExcelReport } from "../../../store/actions/action.Highlighters";
import { ColumnDef } from "@tanstack/react-table";
import { FaStar } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { usersProps } from "../../../../@types";
import FormSelect from "../../forms-component/globalSelect";
import moment from "moment";
export interface Option {
    label: string;
    value: string;
}
export interface FormValues {
    userTeam?: string | null;
    workerNameRef: { value: string }[] | null;
    teamName?: { value: string }[] | null;
    ratingGivenByRef?: { value: string }[] | null;
    projectNameRef: { value: string }[] | null;
    tradeNameRef?: { value: string }[] | null;
}
const AdminReport = () => {
    const [searchParams, setSearchParams] = useSearchParams({
        currentPage: "1",
        limit: "15",
    });
    const [selectedUserTeam, setSelectedUserTeam] = useState<string | null>(null);
    const limit = parseInt(searchParams.get('limit') || "15");
    const currentPage = parseInt(searchParams.get('currentPage') || "1");
    const { dataForTable } = useSelector((state: any) => state.masterData);
    const { createprojectMasterData } = useSelector((state: any) => state.project)
    const userData = useSelector((state: any) => state?.user);
    const { excelReport, loader } = useSelector((state: any) => state?.actionHighlight);
    const [tableData, setTableData] = useState([]);
    const Users = userData?.userData?.data;

    const userOptions = Users?.map((user: any) => ({
        value: user?._id,
        label: `${user?.FirstName} ${user?.LastName}`,
        userTeam: user?.userTeam
    }));
    const projectOptions = dataForTable?.data?.allProjects?.map((project: any) => ({
        value: project?._id,
        label: `${project?.name} `
    }));
    const trade = createprojectMasterData?.allTask?.data?.map((trade: any) => ({
        value: trade._id,
        label: trade?.name
    }))
    const filteredWorkerOptions = selectedUserTeam
        ? userOptions?.filter((user: usersProps) => user?.userTeam === selectedUserTeam)
        : userOptions;
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getAllMasterDataForTable());
        dispatch(getAllProjectMasterData());
        dispatch(getAllUserWithoutPagination())
    }, [])
    useEffect(() => {
        if (excelReport) {
            setTableData(excelReport);
        }
    }, [excelReport]);

    const handleClearFilters = () => {
        setSelectedUserTeam(null);
        formik.resetForm();

    };
    const formik = useFormik<FormValues>({
        initialValues: {
            userTeam: '',
            workerNameRef: [],
            ratingGivenByRef: [],
            projectNameRef: [],
            tradeNameRef: [],
        },
        validate: (values) => {
            const errors: { [key: string]: string } = {};

            if (selectedUserTeam && (!values?.workerNameRef || values?.workerNameRef?.length === 0)) {
                errors.workerNameRef = 'Please select a worker when a user team is chosen';
            }

            return errors;
        },
        onSubmit: (values, { setSubmitting }) => {
            if (selectedUserTeam && (!values.workerNameRef || values.workerNameRef.length === 0)) {
                // setSubmitting(false);
                return;
            }

            const dynamicFilter = Object.keys(values).reduce((acc, key) => {
                const value = values[key as keyof FormValues];
                if (value && Array.isArray(value)) {
                    const idTypes = ["projectId", "userId", "tradeId"];
                    idTypes.forEach((idType) => {
                        const ids = value
                            .map((item: { [key: string]: string }) => item[idType])
                            .filter(Boolean);
                        if (ids.length > 0) {
                            const jsonValue = JSON.stringify(ids);

                            acc.push({
                                type: "array",
                                value: jsonValue,
                                key: key,
                                caseSensitive: false,
                            });
                        }
                    });
                }
                return acc;
            }, [] as { type: string; value: string; key: string; caseSensitive: boolean }[]);

            const finalDynamicFilter =
                dynamicFilter.length > 0
                    ? `[${dynamicFilter
                        .map(
                            (item) =>
                                `{"type":"array","value":"${item.value.replace(/"/g, '\\"')}","key":"${item.key}","caseSensitive":${item.caseSensitive}}`
                        )
                        .join(",")}]`
                    : "[]";

            const payload = `?dynamicFilter=${encodeURIComponent(finalDynamicFilter)}`;

            dispatch(getExcelReport(payload));
            setTableData(excelReport);
            setSubmitting(false);
        },
    });
    const { setFieldValue, values } = formik;

    const columns = useMemo<ColumnDef<any>[]>(() => [
        {
            header: ' Sr.No',
            enableColumnFilter: false,
            accessorKey: "no",
            id: "no",
            cell: ({ row }) => {
                return (
                    <Text >{((currentPage - 1) * limit) + row?.index + 1}</Text>
                )
            }
        },
        {
            header: 'Worker',
            accessorKey: "worker_name",
        },
        {
            header: 'Rating given By',
            accessorKey: "rating_given_by",
        },
        {
            header: 'Review Date',
            accessorKey: "createdAt",
            cell: ({ row }) => {
                const reviewDate = row?.original?.createdAt;
                const formattedDate = moment(reviewDate, "MMMM Do YYYY h:mm:ss a").format("MMM D, YYYY");

                return (
                    <p>{formattedDate || '-'}</p>
                )
            },
        },
        {
            header: 'Project',
            accessorKey: "project_name",
        },
        {
            header: 'Trade',
            accessorKey: "tradeName",
        },
        {
            header: 'Average Rating',
            accessorKey: "average_rating",
        },
        {
            header: 'Criteria',
            accessor: "criteria",
            cell: ({ row }) => {
                return (
                    <div >
                        {row?.original?.criteria?.map((criteria: any, index: any) => {
                            return (
                                <Flex key={index} sx={{ borderTop: `${index !== 0 && "0.5px solid #D3D5D9"}`, paddingY: "5px" }}>
                                    <Text sx={{ fontWeight: "600" }}>{criteria?.rating}</Text> <FaStar color="#FFB721" className='mx-2 mt-1' />
                                    <Paragraph sx={{ textWrap: "nowrap" }}>{criteria?.name}</Paragraph>
                                </Flex>
                            )
                        }
                        )}
                    </div>
                );
            },
        }
    ], [tableData, excelReport]);
    const handleExportClick = (): void => {
        const dataToExport = tableData?.length > 0 ? tableData : excelReport;
        const csvRows: string[] = [];

        // Collect unique criteria names
        const criteriaSet = new Map<string, { mainHeader: string; commentHeader?: string }>();

        dataToExport?.forEach((item: any) => {
            item?.criteria?.forEach((crit: any) => {
                const [mainHeader, comment] = crit.name.split(":").map((part: any) => part.trim());
                if (!criteriaSet.has(mainHeader)) {
                    criteriaSet.set(mainHeader, {
                        mainHeader: `"${mainHeader}"`,
                        commentHeader: comment ? `"${mainHeader}_Comment"` : undefined,
                    });
                }
            });
        });

        // Build headers
        const criteriaHeaders = Array.from(criteriaSet.values());
        const headers: any[] = [
            "Worker",
            "Rating Given By",
            "Rating Date",
            "Project",
            "Trade",
            "Average Rating",
            ...criteriaHeaders.flatMap(c => [c.mainHeader, c.commentHeader].filter(Boolean)),
        ];
        csvRows.push(headers.join(","));

        const replaceCommas = (text: string | null): string => (text ? text.replace(/,/g, "_") : "");

        // Build rows
        dataToExport?.forEach((item: any) => {
            const row: { [key: string]: string } = {
                Worker: `"${replaceCommas(item.worker_name)}"`,
                "Rating Given By": `"${replaceCommas(item.rating_given_by)}"`,
                "Rating Date": `"${replaceCommas(
                    moment(item.createdAt, "MMMM Do YYYY h:mm:ss a").format("MMM D, YYYY")
                )}"`,
                Project: `"${replaceCommas(item.project_name)}"`,
                Trade: `"${replaceCommas(item.tradeName)}"`,
                "Average Rating": `"${replaceCommas(item.average_rating)}"`,
            };

            criteriaHeaders.forEach(({ mainHeader, commentHeader }) => {
                const mainHeaderKey = mainHeader.replace(/"/g, "");
                const matchingCriteria = item.criteria.find(
                    (crit: any) => crit.name.split(":")[0].trim() === mainHeaderKey
                );

                row[mainHeader] = `"${matchingCriteria?.rating || ""}"`;
                if (commentHeader) {
                    row[commentHeader] = `"${matchingCriteria?.name.split(":")[1]?.trim() || ""}"`;
                }
            });

            const rowValues = headers.map(header => row[header] || "");
            csvRows.push(rowValues.join(","));
        });

        // Generate CSV file
        const csvContent = csvRows.join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "Admin_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const dataToDisplay = tableData?.length > 0 ? tableData : excelReport;
    const [colorMode] = useColorMode();
    const thColor = colorMode === 'light' ? '#000' : '#ffffff';
    const label = colorMode === 'light' ? "#0a0a0a" : "#fff";

    return (
        <>
            <div className="main-content px-3" >
                <Box className="d-flex justify-content-between align-items-center" sx={{ mb: 4 }}>
                    <Box className="d-flex align-items-center">
                        <h1 style={{ color: thColor }}>Admin Report</h1>
                        <Button
                            variant='PrimaryHeadBtn'
                            onClick={handleClearFilters}
                            className='toggle-btn'
                            sx={{ ml: 3 }}
                        >
                            Clear Filter
                        </Button>
                    </Box>
                    <HeaderBtn
                        title="Export"
                        onClick={handleExportClick}
                        src={Export}
                        sx={{ padding: '10px 10px' }}
                    />
                </Box>
                <Divider sx={{ color: '#D9D7DD' }} opacity={2} my={[3, 3, 4]} />
                <form onSubmit={formik.handleSubmit}>
                    <Flex>
                        <div className="col-2 px-1">
                            <FormSelect
                                label={"User Team:"}
                                sx={{ color: label }}
                                value={selectedUserTeam ? { value: selectedUserTeam, label: selectedUserTeam } : null}
                                placeholder={"Select User Team"}
                                options={[
                                    { value: "QDC", label: "QDC" },
                                    { value: "PEC", label: "PEC" },
                                ]}
                                isMulti={false}
                                onChange={(selectedOption: any) => {
                                    setSelectedUserTeam(selectedOption?.value || null);
                                    setFieldValue("workerNameRef", null);
                                }}
                            />
                        </div>
                        <div className="col-3 px-1">
                            <FormSelect
                                label={"Rating Given By:"}
                                sx={{ color: label }}

                                value={values?.ratingGivenByRef}
                                placeholder={"Select"}
                                options={userOptions || []}
                                isMulti={false}
                                Name='ratingGivenByRef'
                                onChange={(selectedrating: any) => {
                                    const selectedId = selectedrating?.value || null;
                                    setFieldValue('ratingGivenByRef', selectedId);
                                }}
                            />
                        </div>
                        <div className="col-3 px-1">
                            <FormSelect
                                label={"Project Name:"}
                                sx={{ color: label }}

                                value={values?.projectNameRef}
                                placeholder={"Select Project"}
                                options={projectOptions || []}
                                isMulti={false}
                                Name='projectNameRef'
                                onChange={(selectedProject: any) => {
                                    const selectedId = selectedProject?.value || null;
                                    setFieldValue('projectNameRef', selectedId);
                                }}
                            />
                        </div>
                        <div className="col-3">
                            <FormSelect
                                label={"Trade:"}
                                sx={{ color: label }}

                                value={values?.tradeNameRef}
                                placeholder={"Select Trade"}
                                options={trade || []}
                                isMulti={false}
                                Name='tradeNameRef'
                                onChange={(selectedTrade: any) => {
                                    const selectedId = selectedTrade?.value || null;
                                    setFieldValue('tradeNameRef', selectedId);
                                }}
                            />
                        </div>

                    </Flex>
                    <Box className="mt-4 px-2 d-flex justify-content-end">
                        <Button
                            className="mx-2"
                            variant="SaveButton"
                            type='submit'
                            disabled={selectedUserTeam && (!values.workerNameRef || values.workerNameRef.length === 0) ? true : undefined}
                        >Preview</Button>
                    </Box>
                </form>
                <Box className="mt-3 report-table-column">
                    <DataTable
                        loader={loader}
                        columns={columns}
                        fixedColumn={true}
                        data={dataToDisplay || []}
                        TotalLength={15}
                        perPageCount={15}
                        currentPage={1}
                        showNavigation={false}
                        onPerPageChange={() => { }}
                        onPageChange={() => { }}
                    />
                </Box>
            </div >
        </>
    )
}
export default AdminReport